"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneError = void 0;
exports.cloneError = function (originalError) {
    // @ts-ignore
    var error = new originalError.constructor();
    var propsToCopy = [
        'message',
        'stack',
        'name',
        'filename',
        'lineNumber',
        'columnNumber',
    ];
    for (var _i = 0, propsToCopy_1 = propsToCopy; _i < propsToCopy_1.length; _i++) {
        var prop = propsToCopy_1[_i];
        if (originalError[prop]) {
            error[prop] = originalError[prop];
        }
    }
    return error;
};
//# sourceMappingURL=cloneError.js.map